import styled from 'styled-components';

export const RegistrationForm = styled.div`
form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 15px;

  .field .react-select__control {
    border: 0;
    color: #646464;
    background-color: #f0f0f0;
  }
}

.lg {
  grid-column: 1/3;
}

.industry.error label {
  color: red;
}

.industry label {
  color: #646464;
}

.info {
  color: grey;
  font-size: 12px;
  margin-bottom: -10px;
}

p {
  margin: 0px;
}

.footer {
  margin-top: 0px;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  form {
    display: block;

    input[type="text"] {
      margin: 15px 0px;
    }

    input[type="checkbox"] {
      margin: 5px 0px;
    }
  }

  p.info {
    margin-bottom: 10px;
  }
}
`;

export const SubmitButton = styled.button`
  position: relative;
  font-size: 20px;
  text-transform: uppercase;
  width: 100%;
  height: 40px;
  border-radius: 0px;
  cursor: pointer;
  text-align: center;
  outline: none;
  color: #000;
  transition: 0.5s all;

  font-weight: 700;
  border: 2px solid #000;
  background-color: transparent;
  background-image: none;
  letter-spacing: 1px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &:hover {
    color: #fff;
    border: 2px solid #000;
    background-color: #000;
  }
`

export const Input = styled.input`
  font-size: 16px;
  display: block;
  width: calc(100% - 10px);
  height: 30px;
  color: black;
  outline: none;
  border-radius: 4px;
  border: none;
  background-color: #f0f0f0;
  transition: 0.2s all;
  padding: 5px 0px 5px 10px;

  &::-webkit-input-placeholder,
  &::-moz-placeholder,
  &:-ms-input-placeholder,
  &:-moz-placeholder
  &::placeholder {
    color: #9e9e9e;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
  }
  &:focus {
    color: #8733FF;
    border-left: 10px solid #8733FF;
  }
`;
